// extracted by mini-css-extract-plugin
export var addButton = "_il-0";
export var border = "_il-8";
export var check = "_il-h";
export var danger = "_il-6";
export var dropdownContainer = "_il-1";
export var editModalBody = "_il-j";
export var footerContainer = "_il-i";
export var fullWidth = "_il-a";
export var hide = "_il-9";
export var icon = "_il-3";
export var input = "_il-7";
export var inputFlex = "_il-b";
export var inputWrapper = "_il-c";
export var manualFocus = "_il-5";
export var optionButton = "_il-4";
export var pillWrapper = "_il-e";
export var pointer = "_il-2";
export var showOverflow = "_il-f";
export var tagsFlex = "_il-d";
export var xButton = "_il-g";